/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
// ===== ARCHIVO: modules/jobsWorkdayItem.js =====

// ===== CONFIGURACIÓN Y VARIABLES GLOBALES =====
let translations = {};
let localization = "en-US";
let jobAreasList = {};
let locationsList = {};
let statesList = {};
let baseUrl = "";
let jobItem = "";

// ===== INICIALIZACIÓN DE TRADUCCIONES =====
function initializeTranslations() {
    // Usar la localización del servidor si está disponible
    localization = window.serverLocalization || "en-US";

    translations = {
        "en-US": {
            back_to_search: "Back to Search",
            loc: "Location",
            category: "Category",
            posted: "Posted",
            type: "Type",
            job_type: "Job Type",
            similar_job_title: "Similar Jobs",
            "Full time": "Full time",
            "Part time": "Part time",
            "Contingent Worker": "Contingent Worker",
            "Permanent Employee": "Permanent Employee",
            "Temporary Employee": "Temporary Employee"
        },
        "zh-CN": {
            back_to_search: "返回搜索",
            loc: "地点",
            category: "类别",
            posted: "已发布",
            type: "类型",
            job_type: "工作类型",
            similar_job_title: "类似职位",
            "Full time": "全职工作",
            "Part time": "兼职工作",
            "Contingent Worker": "临时工",
            "Permanent Employee": "全职工作",
            "Temporary Employee": "兼职工作"
        },
        "es-ES": {
            back_to_search: "Volver a la búsqueda",
            loc: "Ubicación",
            category: "Categoría",
            posted: "Publicado",
            type: "Tipo",
            job_type: "Tipo de Empleo",
            similar_job_title: "Empleos Similares",
            "Full time": "Tiempo completo",
            "Part time": "Medio tiempo",
            "Contingent Worker": "Trabajador Eventual",
            "Permanent Employee": "Empleado Permanente",
            "Temporary Employee": "Empleado Temporal"
        }
    };

    // Hacer disponibles globalmente
    window.translations = translations;
    window.localization = localization;
}

// ===== FUNCIONES DE API =====
async function getCategories(categoryType) {
    let apiBaseUrl = window.location.origin;
    if (window.location.hostname.includes("localhost")) {
        apiBaseUrl += "/local";
    }
    const url = apiBaseUrl + "/.rest/delivery/getCategories?categoryType=" + categoryType + "&limit=10000";

    const response = await fetch(url);
    if (!response.ok) throw new Error("Network error");

    const data = await response.json();
    const formattedData = data.results.reduce((acc, item) => {
        acc[item.name] = {
            "en-US": item.name,
            "zh-CN": item[categoryType + "translation_chinese"],
            "es-ES": item[categoryType + "translation_spanish"]
        };
        return acc;
    }, {});

    return formattedData;
}

// ===== FUNCIONES DE PROCESAMIENTO DE CONTENIDO =====
function processJobDescription(jobItem, description) {
    // --- Initial Setup (no changes) ---
    const enableFormatting = false; // ← Cambiar a true para activar el formato

    const [year, month, day] = jobItem.Start_Date.split("-");
    const startDate = new Date(year, month - 1, day);
    const dateOptions = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
    const formattedDate = startDate.toLocaleDateString(localization, dateOptions);
    const rawHtml = jobItem[description] || "";

    if (!enableFormatting) {
        return rawHtml;
    }

    let finalDescription = "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = rawHtml;

    // --- IMPROVED LOGIC FOR BR-SEPARATED CONTENT ---

    // Helper functions
    const subtitleKeywords = ["duties and responsibilities", "qualification and skills", "benefits", "job summary", "responsibilities", "requirements", "qualifications", "skills", "summary", "education", "experience", "knowledge requirements", "management supervisory responsibilities", "physical demands", "job qualifications"];

    const isAllUppercase = text => {
        const letters = text.replace(/[^a-zA-Z]/g, "");
        return letters.length > 3 && letters === letters.toUpperCase();
    };

    const isSubtitle = text => {
        return isAllUppercase(text) || (text.length < 100 && subtitleKeywords.some(keyword => text.toLowerCase().includes(keyword)));
    };

    const cleanText = text => {
        return text
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/§/g, "·") // Convert the wrong character back to bullet
            .trim();
    };

    const isBulletPoint = text => {
        const cleanedText = cleanText(text);
        return cleanedText.startsWith("·") || cleanedText.startsWith("•") || cleanedText.startsWith("-") || cleanedText.startsWith("§"); // Also check for the converted character
    };

    // Check the type of content we're dealing with
    const hasBreakTags = rawHtml.includes("<br");
    const hasStructuredLists = rawHtml.includes("<li") || rawHtml.includes("<ul");
    const hasTextBullets = rawHtml.includes("·") || rawHtml.includes("•") || rawHtml.includes("-");

    if (hasBreakTags) {
        // --- PATH 1: CONTENT WITH <br> TAGS ---

        const finalContainer = document.createElement("div");
        let currentList = null;

        // First, get the text content and replace <br> with newlines
        let processedHtml = rawHtml;

        // Replace <br> variants with newlines
        processedHtml = processedHtml.replace(/<br\s*\/?>/gi, "\n");

        // Create a temporary div to decode HTML entities
        const decoder = document.createElement("div");
        decoder.innerHTML = processedHtml;
        const decodedText = decoder.textContent || decoder.innerText || "";

        // Split by lines and process each line
        const lines = decodedText.split("\n");

        lines.forEach(line => {
            const cleanedLine = cleanText(line);
            if (!cleanedLine) return;

            // Check if it's a bullet point
            if (isBulletPoint(cleanedLine)) {
                if (!currentList) {
                    currentList = document.createElement("ul");
                    finalContainer.appendChild(currentList);
                }

                const li = document.createElement("li");
                let bulletText = cleanedLine;
                // Remove any bullet character (·, •, -, §)
                if (bulletText.startsWith("·") || bulletText.startsWith("•") || bulletText.startsWith("-") || bulletText.startsWith("§")) {
                    bulletText = bulletText.substring(1).trim();
                }
                li.textContent = bulletText;
                currentList.appendChild(li);
            } else if (isSubtitle(cleanedLine)) {
                // This is a subtitle
                currentList = null;
                const span = document.createElement("span");
                span.className = "subtitle-jobs";
                span.textContent = cleanedLine;
                finalContainer.appendChild(span);
            } else {
                // Regular paragraph
                currentList = null;
                const p = document.createElement("p");
                p.textContent = cleanedLine;
                finalContainer.appendChild(p);
            }
        });

        finalDescription = finalContainer.innerHTML;

        // Post-process the generated HTML to fix any remaining bullets
        const finalDiv = document.createElement("div");
        finalDiv.innerHTML = finalDescription;

        // Find all elements that start with § and convert them to list items
        const allElements = finalDiv.querySelectorAll("p, span");
        let pendingListItems = [];

        allElements.forEach(element => {
            const text = element.textContent.trim();
            if (text.startsWith("§")) {
                // This should be a bullet point
                const cleanBulletText = text
                    .substring(1)
                    .replace(/\s+/, " ")
                    .trim();

                // Check if this is actually a subtitle (short text with keywords)
                if (isSubtitle(cleanBulletText)) {
                    element.className = "subtitle-jobs";
                    element.textContent = cleanBulletText;
                } else {
                    // Convert to list item
                    pendingListItems.push({
                        element: element,
                        text: cleanBulletText
                    });
                }
            }
        });

        // Process the pending list items
        let currentProcessingList = null;
        pendingListItems.forEach(item => {
            const element = item.element;
            const text = item.text;

            // Find or create a list
            if (!currentProcessingList || element.previousElementSibling !== currentProcessingList) {
                currentProcessingList = document.createElement("ul");
                element.parentNode.insertBefore(currentProcessingList, element);
            }

            const li = document.createElement("li");
            li.textContent = text;
            currentProcessingList.appendChild(li);
            element.remove();
        });

        finalDescription = finalDiv.innerHTML;
    } else if (hasStructuredLists && hasTextBullets) {
        // --- PATH 2: HYBRID CONTENT - Process both structured and unstructured ---

        const finalContainer = document.createElement("div");
        let currentList = null;

        // Get all direct children of tempDiv
        const children = Array.from(tempDiv.children);

        children.forEach(element => {
            const textContent = element.textContent.trim();

            if (!textContent) return;

            // Check if this element already contains a structured list
            if (element.querySelector("ul, ol, li")) {
                // This is already structured - just clean it up
                element.querySelectorAll("b, strong").forEach(el => {
                    const span = document.createElement("span");
                    span.className = "subtitle-jobs";
                    span.innerHTML = el.innerHTML;
                    el.replaceWith(span);
                });

                // Remove empty elements
                element.querySelectorAll("p, span, div").forEach(el => {
                    if (el.innerHTML.trim() === "" || el.innerHTML.trim() === "&nbsp;") {
                        el.remove();
                    }
                });

                currentList = null;
                finalContainer.appendChild(element.cloneNode(true));
            } else if (textContent.startsWith("•") || textContent.startsWith("·") || textContent.startsWith("-")) {
                // This is a bullet item - convert to list
                if (!currentList) {
                    currentList = document.createElement("ul");
                    finalContainer.appendChild(currentList);
                }

                const li = document.createElement("li");
                li.textContent = cleanText(textContent.substring(1));
                currentList.appendChild(li);
            } else if (isSubtitle(textContent)) {
                // This is a subtitle
                currentList = null;
                const span = document.createElement("span");
                span.className = "subtitle-jobs";
                span.textContent = cleanText(textContent);
                finalContainer.appendChild(span);
            } else {
                // Regular paragraph - but check if it contains subtitle spans
                currentList = null;

                // Check if this element contains potential subtitles
                const boldElements = element.querySelectorAll("b, strong");
                boldElements.forEach(el => {
                    const span = document.createElement("span");
                    span.className = "subtitle-jobs";
                    span.innerHTML = el.innerHTML;
                    el.replaceWith(span);
                });

                finalContainer.appendChild(element.cloneNode(true));
            }
        });

        // Post-process to handle any remaining bullets that might be in nested elements
        const remainingBullets = finalContainer.querySelectorAll("p, div");
        remainingBullets.forEach(el => {
            const text = el.textContent.trim();
            if (text.startsWith("•") || text.startsWith("·") || text.startsWith("-")) {
                // Convert this to a list item
                let parentList = el.previousElementSibling;
                if (!parentList || parentList.tagName !== "UL") {
                    parentList = document.createElement("ul");
                    el.parentNode.insertBefore(parentList, el);
                }

                const li = document.createElement("li");
                li.textContent = cleanText(text.substring(1));
                parentList.appendChild(li);
                el.remove();
            }
        });

        finalDescription = finalContainer.innerHTML;
    } else if (hasStructuredLists) {
        // --- PATH 3: STRUCTURED CONTENT ONLY ---

        // Convert bold/strong tags to subtitles
        tempDiv.querySelectorAll("b, strong").forEach(el => {
            const span = document.createElement("span");
            span.className = "subtitle-jobs";
            span.innerHTML = el.innerHTML;
            el.replaceWith(span);
        });

        // Clean up empty tags
        tempDiv.querySelectorAll("p, span, div").forEach(el => {
            if (el.innerHTML.trim() === "" || el.innerHTML.trim() === "&nbsp;") {
                el.remove();
            }
        });

        finalDescription = tempDiv.innerHTML;
    } else {
        // --- PATH 4: UNSTRUCTURED TEXT WITH BULLETS ---

        const finalContainer = document.createElement("div");
        let currentList = null;

        const allText = tempDiv.textContent || "";
        const lines = allText.split("\n");

        lines.forEach(line => {
            const text = cleanText(line);
            if (!text) return;

            if (text.startsWith("·") || text.startsWith("•") || text.startsWith("-")) {
                if (!currentList) {
                    currentList = document.createElement("ul");
                    finalContainer.appendChild(currentList);
                }
                const li = document.createElement("li");
                li.textContent = text.substring(1).trim();
                currentList.appendChild(li);
            } else if (isSubtitle(text)) {
                currentList = null;
                const span = document.createElement("span");
                span.className = "subtitle-jobs";
                span.textContent = text;
                finalContainer.appendChild(span);
            } else {
                currentList = null;
                const p = document.createElement("p");
                p.textContent = text;
                finalContainer.appendChild(p);
            }
        });

        finalDescription = finalContainer.innerHTML;
    }
    return finalDescription;
}

// ===== FUNCIONES DE FORMATO =====
function formatLocations(locations) {
    return locations
        .map(item => {
            const region = item["Location_Address_-_State_Province_Region"] || "";
            const country = item["Location_Address_-_Country"] || "";
            const city = (item["Location"] && item["Location"].split(",")[0] && item["Location"].split(",")[0].trim()) || (item["Location_Address_-_City"] && item["Location_Address_-_City"].split(",")[0] && item["Location_Address_-_City"].split(",")[0].trim()) || "";

            if (!city) return null;

            const locationName = window.locationsList && window.locationsList[city] && window.locationsList[city][localization] ? window.locationsList[city][localization] : city;
            const stateName = window.statesList && window.statesList[region] && window.statesList[region][localization] ? window.statesList[region][localization] : "";

            if (locationName && (locationName.toLowerCase().includes("remote") || locationName.toLowerCase().includes("remoto"))) {
                return locationName + ".";
            }

            return (locationName ? locationName + ", " : "") + (stateName ? stateName + ", " : "") + country + ".";
        })
        .filter(Boolean)
        .join("<br>");
}

function formatDate(dateString) {
    const [year, month, day] = dateString.split("-");
    const startDate = new Date(year, month - 1, day);
    const dateOptions = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
    return startDate.toLocaleDateString(localization, dateOptions);
}

// ===== FUNCIONES DE VIDEO =====
function getVideoPlayerHTML(videoUrl) {
    if (!videoUrl) return "";

    let videoID = "";
    let videoSrc = "";

    const youtubeMatch = videoUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w\-]+)/);
    const vidyardMatch = videoUrl.match(/(?:vidyard\.com\/(?:watch\/|embed\/)?)([\w\-]+)/);

    if (youtubeMatch) {
        videoID = youtubeMatch[1];
        videoSrc = "youtube";
    } else if (vidyardMatch) {
        videoID = vidyardMatch[1];
        videoSrc = "vidyard";
    }

    if (!videoID || !videoSrc) return "";

    if (videoSrc === "youtube") {
        return `<div id="video-player" class="container-title" style="margin-bottom: 24px;">
            <h2>Watch</h2>
            <div class="line-style"></div>
            <div class="video-container wrap light-theme">
                <div class="video-youtube">
                    <iframe class="video-embed" style="width: 100%;" src="https://www.youtube.com/embed/${videoID}" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>`;
    } else if (videoSrc === "vidyard") {
        return `<div id="video-player" class="container-title">
            <h2>Watch</h2>
            <div class="line-style"></div>
            <div class="video-container wrap light-theme">
                <div class="video video-vidyard">
                    <div class="video-wrapper">
                        <iframe class="video-embed" src="https://play.vidyard.com/${videoID}.html" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>`;
    }

    return "";
}

// ===== FUNCIONES DE TRABAJOS RELACIONADOS =====
function setRelatedJobs(job, jobsList) {
    const city = job.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location"].split(",")[0].trim();
    const jobFamilyGroup = job["Job_Family_Group"];
    const region = job.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location_Address_-_State_Province_Region"];

    const filteredJobs = jobsList.filter(item => {
        if (item === job) return false;
        const matchesCity = item.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location"].split(",")[0].trim() === city;
        const matchesJobFamily = item["Job_Family_Group"] === jobFamilyGroup;
        return matchesCity && matchesJobFamily;
    });

    const prioritizedJobs = filteredJobs.sort((a, b) => {
        const aMatchesCity = a.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location"].split(",")[0].trim() === city;
        const aMatchesJobFamily = a["Job_Family_Group"] === jobFamilyGroup;
        const bMatchesCity = b.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location"].split(",")[0].trim() === city;
        const bMatchesJobFamily = b["Job_Family_Group"] === jobFamilyGroup;

        return (bMatchesCity && bMatchesJobFamily) - (aMatchesCity && aMatchesJobFamily);
    });

    let top5Jobs = prioritizedJobs.slice(0, 5);

    if (top5Jobs.length < 5) {
        const remainingJobs = jobsList.filter(item => {
            if (item === job || top5Jobs.includes(item)) return false;
            const matchesState = item.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location_Address_-_State_Province_Region"] === region;
            return matchesState;
        });
        top5Jobs = top5Jobs.concat(remainingJobs.slice(0, 6 - top5Jobs.length));
    }

    if (top5Jobs.length > 0) {
        const similarJobContainer = document.querySelector("#similar-jobs");
        if (similarJobContainer) {
            similarJobContainer.classList.remove("hidden");

            const ulElement = similarJobContainer.querySelector("ul");
            if (ulElement) {
                top5Jobs.forEach(item => {
                    const liElement = document.createElement("li");
                    const aElement = document.createElement("a");
                    aElement.classList.add("call-to-action");
                    aElement.textContent = item.Job_Posting_Title;

                    const countryName = item.All_Job_Posting_Locations_for_Job_Requisition_group[0]["Location_Address_-_Country"]
                        .split(",")[0]
                        .trim()
                        .toLowerCase();
                    const url = window.location.pathname + "?jobItem=" + item.Job_Requisition_ID + "-" + item.Job_Category.trim() + "-" + countryName + "-" + item["Job_Posting_Title"];

                    aElement.href = url.toLowerCase().replace(/\s+/g, "-");
                    aElement.innerHTML += `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25504 0.5L9.75496 7.99928L2.2552 15.5L0 13.2451L5.2449 7.99952L8.31182e-05 2.75515L2.25504 0.5Z" />
                    </svg>`;

                    liElement.appendChild(aElement);

                    const pElement = document.createElement("p");
                    pElement.textContent = "Req ID: " + (item.Job_Requisition_ID || "") + " - " + (item.Job_Category || "");
                    liElement.appendChild(pElement);

                    ulElement.appendChild(liElement);
                });
            }
        }
    }
}

// ===== FUNCIÓN PRINCIPAL DE RENDERIZADO =====
function renderJobItem(jobFiltered, currentUrl, articleTitle) {
    // Formatear fecha
    const formattedDate = formatDate(jobFiltered.Start_Date);

    // Procesar descripción
    const finalDescription = processJobDescription(jobFiltered, "Job_Description");
    const aditionalDescription = processJobDescription(jobFiltered, "Additional_Job_Description");

    // Formatear ubicaciones
    const formattedLocations = formatLocations(jobFiltered.All_Job_Posting_Locations_for_Job_Requisition_group);

    // Determinar tipo de trabajo
    const type = jobFiltered["Time_Type"].toLowerCase().includes("part") ? translations[localization]["Part time"] : translations[localization]["Full time"];

    const jobType = translations[localization][jobFiltered["Worker_sub-type_ENG"]] || jobFiltered["Worker_sub-type_ENG"];

    // Obtener video HTML
    const videoPlayerHTML = getVideoPlayerHTML(jobFiltered.videoHyperlink);

    // URLs para compartir
    const emailSubject = encodeURIComponent(articleTitle || "");
    const emailBody = encodeURIComponent("Check out this job opportunity at Jabil:\n\n" + currentUrl);

    // Actualizar elementos del DOM
    const titleElement = document.querySelector("#title");
    const reqIdElement = document.querySelector("#req_id");
    const backButton = document.querySelector("#backLink-style");
    const containerIconJob = document.querySelector(".container-icons-job");
    const jobElement = document.getElementById("job-item");

    if (titleElement) titleElement.innerText = jobFiltered.Job_Posting_Title || "Job Description";
    if (reqIdElement) reqIdElement.innerText = "Req ID: " + (jobFiltered.Job_Requisition_ID || "") + (jobFiltered.Job_Category ? "-" + jobFiltered.Job_Category : "");
    if (backButton) {
        backButton.append(translations[localization].back_to_search);
    }

    // Renderizar iconos de información del trabajo
    if (containerIconJob) {
        containerIconJob.innerHTML = `
            <div class="icon-job">
                <!-- SVG del ícono de ubicación -->
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_63_5511)"><mask id="mask0_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 0H32V32H0V0Z" fill="white"></path></mask><g mask="url(#mask0_63_5511)"><mask id="mask1_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 32H32V0H0V32Z" fill="white"></path></mask><g mask="url(#mask1_63_5511)"><path d="M16.0275 15.0361C14.0998 15.0361 12.5026 13.4389 12.5026 11.5112C12.5026 9.58346 14.0998 7.98621 16.0275 7.98621C17.9553 7.98621 19.5525 9.58346 19.5525 11.5112C19.4974 13.494 17.9553 15.0361 16.0275 15.0361ZM16.0275 6.93974C13.494 6.93974 11.4561 9.03269 11.4561 11.5662C11.4561 14.0998 13.494 16.1377 16.0275 16.1377C18.5611 16.1377 20.6541 14.0998 20.6541 11.5662C20.6541 9.03269 18.5611 6.93974 16.0275 6.93974Z" fill="#0164A1"></path></g><mask id="mask2_63_5511" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M0 32H32V0H0V32Z" fill="white"></path></mask><g mask="url(#mask2_63_5511)"><path d="M25.4458 12.0069C25.5559 17.6248 17.9552 27.1532 16.0275 29.4114C14.1549 27.1532 6.44406 17.6248 6.60929 12.0069V11.7866C6.60929 11.7315 6.60929 11.6764 6.60929 11.6213C6.60929 11.6213 6.60929 11.5663 6.60929 11.5112C6.60929 6.27882 10.8503 2.09293 15.9725 2.09293C21.0947 2.09293 25.4458 6.3339 25.4458 11.5663C25.4458 11.6213 25.4458 11.6764 25.3907 11.6764C25.3907 11.7315 25.3907 11.7866 25.3907 11.8967L25.4458 12.0069ZM26.5473 11.7866C26.5473 11.6764 26.5473 11.6213 26.5473 11.5663C26.5473 5.78312 21.8107 1.04646 16.0275 1.04646C10.2444 1.04646 5.50774 5.78312 5.50774 11.5663C5.50774 11.6213 5.50774 11.6764 5.50774 11.7315V11.7866V11.8967C5.50774 11.9518 5.50774 12.0069 5.50774 12.062C5.34251 18.7263 14.8709 29.7969 15.5869 30.6231C15.642 30.7332 15.6971 30.7332 15.8623 30.7883C15.9174 30.8434 15.9725 30.8434 16.0275 30.8434C16.1377 30.8434 16.1928 30.8434 16.2478 30.7883C16.358 30.7332 16.4131 30.6781 16.5232 30.6231C17.074 29.907 26.7676 18.7263 26.5473 12.0069C26.5473 11.8967 26.5473 11.8967 26.5473 11.8416V11.7866Z" fill="#0164A1"></path></g></g></g><defs><clipPath id="clip0_63_5511"><rect width="32" height="32" fill="white"></rect></clipPath></defs></svg>
                <div class="wrapper-text-job">
                    <p class="title-category-job">${translations[localization].loc}</p>
                    <p class="title-content-job">${formattedLocations}</p>
                </div>
            </div>
            <div class="icon-job">
                <!-- SVG del ícono de categoría -->
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4_4235)"><mask id="mask0_4_4235" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 0H48V48H0V0Z" fill="white"></path></mask><g mask="url(#mask0_4_4235)"><mask id="mask1_4_4235" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask1_4_4235)"><path d="M4.38656 19.6137L13.9038 28.8826C14.0693 29.0481 14.2348 29.2964 14.1521 29.6274L11.9176 42.7033L23.6693 36.4964C23.9176 36.3309 24.1659 36.3309 24.4141 36.4964L36.1659 42.7033L33.9314 29.6274C33.8486 29.2964 34.0141 29.0481 34.1797 28.8826L43.6969 19.6137L30.5383 17.7102C30.29 17.7102 30.0417 17.5447 29.8762 17.2964L24.0004 5.37917L18.1245 17.2964C17.959 17.5447 17.7935 17.7102 17.4624 17.7102L4.38656 19.6137ZM37.3245 45.1033C37.159 45.1033 37.0762 45.0205 36.9107 44.9378L24.0004 38.2343L11.1728 45.0205C10.8417 45.1861 10.5107 45.1861 10.2624 44.9378C10.0141 44.7723 9.84863 44.4412 9.84863 44.1102L12.4141 29.793L1.98656 19.6137C1.82104 19.4481 1.73828 19.0343 1.82104 18.7861C1.9038 18.5378 2.15208 18.2895 2.48311 18.2068L16.8831 16.1378L23.2555 3.14469C23.5866 2.56538 24.4969 2.56538 24.7452 3.14469L31.2004 16.1378L45.5176 18.2068C45.9314 18.2895 46.1797 18.5378 46.1797 18.8688C46.3452 19.1171 46.2624 19.5309 46.0141 19.6964L35.6693 29.793L38.0693 44.1102C38.1521 44.4412 37.9866 44.7723 37.7383 44.9378C37.5728 45.0205 37.49 45.1033 37.3245 45.1033Z" fill="#0990CF"></path></g></g></g><defs><clipPath id="clip0_4_4235"><rect width="48" height="48" fill="white"></rect></clipPath></defs></svg>
                <div class="wrapper-text-job">
                    <p class="title-category-job">${translations[localization].category}</p>
                    <p class="title-content-job">${(jobAreasList[jobFiltered.Job_Family_Group] && jobAreasList[jobFiltered.Job_Family_Group][localization]) || ""}</p>
                </div>
            </div>
            <div class="icon-job">
                <!-- SVG del ícono de fecha -->
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4_4251)"><mask id="mask0_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 0H48V48H0V0Z" fill="white"></path></mask><g mask="url(#mask0_4_4251)"><mask id="mask1_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask1_4_4251)"><path d="M12.0826 39.8897H7.86196V35.669H12.0826V39.8897ZM12.9102 34.0138H7.03437C6.62058 34.0138 6.20679 34.4276 6.20679 34.9241V40.8C6.20679 41.2138 6.62058 41.6276 7.03437 41.6276H12.9102C13.324 41.6276 13.7378 41.2138 13.7378 40.8V34.9241C13.7378 34.4276 13.4068 34.0138 12.9102 34.0138Z" fill="#0990CF"></path></g><mask id="mask2_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask2_4_4251)"><path d="M21.4345 39.8897H17.2138V35.669H21.4345V39.8897ZM22.262 34.0138H16.4689C15.9724 34.0138 15.5586 34.4276 15.5586 34.9241V40.8C15.5586 41.2138 15.9724 41.6276 16.4689 41.6276H22.262C22.7586 41.6276 23.1724 41.2138 23.1724 40.8V34.9241C23.1724 34.4276 22.7586 34.0138 22.262 34.0138Z" fill="#0990CF"></path></g><mask id="mask3_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask3_4_4251)"><path d="M30.7858 39.8898H26.5651V35.6691H30.7858V39.8898ZM31.6134 34.0139H25.7375C25.3237 34.0139 24.9099 34.4277 24.9099 34.9243V40.8001C24.9099 41.2139 25.3237 41.6277 25.7375 41.6277H31.6134C32.0272 41.6277 32.4409 41.2139 32.4409 40.8001V34.9243C32.4409 34.4277 32.1099 34.0139 31.6134 34.0139Z" fill="#0990CF">
                </path></g><mask id="mask4_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask4_4_4251)"><path d="M12.0826 30.7035H7.86196V26.4828H12.0826V30.7035ZM12.9102 24.9104H7.03437C6.62058 24.9104 6.20679 25.3242 6.20679 25.738V31.6138C6.20679 32.0276 6.62058 32.4414 7.03437 32.4414H12.9102C13.324 32.4414 13.7378 32.0276 13.7378 31.6138V25.738C13.7378 25.2414 13.4068 24.9104 12.9102 24.9104Z" fill="#0990CF"></path></g><mask id="mask5_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask5_4_4251)"><path d="M21.4345 30.7035H17.2138V26.4828H21.4345V30.7035ZM22.262 24.9104H16.4689C15.9724 24.9104 15.5586 25.3242 15.5586 25.738V31.6138C15.5586 32.0276 15.9724 32.4414 16.4689 32.4414H22.262C22.7586 32.4414 23.1724 32.0276 23.1724 31.6138V25.738C23.1724 25.2414 22.7586 24.9104 22.262 24.9104Z" fill="#0990CF"></path></g><mask id="mask6_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask6_4_4251)"><path d="M30.7858 30.7035H26.5651V26.4828H30.7858V30.7035ZM31.6134 24.9104H25.7375C25.3237 24.9104 24.9099 25.3242 24.9099 25.738V31.6138C24.9099 32.0276 25.3237 32.4414 25.7375 32.4414H31.6134C32.0272 32.4414 32.4409 32.0276 32.4409 31.6138V25.738C32.4409 25.2414 32.1099 24.9104 31.6134 24.9104Z" fill="#0990CF"></path></g><mask id="mask7_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask7_4_4251)">
                <path d="M40.1383 30.7035H35.9176V26.4828H40.1383V30.7035ZM40.9659 24.9104H35.1728C34.6762 24.9104 34.2625 25.3242 34.2625 25.738V31.6138C34.2625 32.0276 34.6762 32.4414 35.1728 32.4414H40.9659C41.4624 32.4414 41.8762 32.0276 41.8762 31.6138V25.738C41.8762 25.2414 41.4624 24.9104 40.9659 24.9104Z" fill="#0990CF"></path></g><mask id="mask8_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask8_4_4251)"><path d="M21.4345 21.6H17.2138V17.3793H21.4345V21.6ZM22.262 15.7241H16.4689C15.9724 15.7241 15.5586 16.1379 15.5586 16.5517V22.4276C15.5586 22.8414 15.9724 23.2552 16.4689 23.2552H22.262C22.7586 23.2552 23.1724 22.8414 23.1724 22.4276V16.5517C23.1724 16.0552 22.7586 15.7241 22.262 15.7241Z" fill="#0990CF"></path></g><mask id="mask9_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask9_4_4251)"><path d="M30.7858 21.6H26.5651V17.3793H30.7858V21.6ZM31.6134 15.7241H25.7375C25.3237 15.7241 24.9099 16.1379 24.9099 16.5517V22.4276C24.9099 22.8414 25.3237 23.2552 25.7375 23.2552H31.6134C32.0272 23.2552 32.4409 22.8414 32.4409 22.4276V16.5517C32.4409 16.0552 32.1099 15.7241 31.6134 15.7241Z" fill="#0990CF"></path></g><mask id="mask10_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask10_4_4251)"><path d="M40.1383 21.6H35.9176V17.3793H40.1383V21.6ZM40.9659 15.7241H35.1728C34.6762 15.7241 34.2625 16.1379 34.2625 16.5517V22.4276C34.2625 22.8414 34.6762 23.2552 35.1728 23.2552H40.9659C41.4624 23.2552 41.8762 22.8414 41.8762 22.4276V16.5517C41.8762 16.0552 41.4624 15.7241 40.9659 15.7241Z" fill="#0990CF"></path>
                </g><mask id="mask11_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask11_4_4251)"><path d="M42.5378 43.7793H5.54473C4.79991 43.7793 4.13784 43.1173 4.13784 42.3724V12.6621H43.9447V42.3724C43.9447 43.1173 43.2827 43.7793 42.5378 43.7793ZM5.54473 3.97243H42.5378C43.2827 3.97243 43.9447 4.6345 43.9447 5.37933V11.0897H4.13784V5.37933C4.13784 4.6345 4.71715 3.97243 5.54473 3.97243ZM42.5378 2.31726H5.54473C3.8068 2.31726 2.48267 3.72416 2.48267 5.37933V42.3724C2.48267 44.0276 3.8068 45.3517 5.46198 45.3517H42.4551C44.1103 45.3517 45.5172 44.0276 45.5172 42.3724V5.37933C45.5999 3.72416 44.193 2.31726 42.5378 2.31726Z" fill="#0990CF"></path></g><mask id="mask12_4_4251" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask12_4_4251)"><path d="M15.8066 8.35866H31.6135C32.0273 8.35866 32.4411 7.94487 32.4411 7.53107C32.4411 7.03452 32.0273 6.62073 31.6135 6.62073H15.8066C15.3928 6.62073 14.979 7.03452 14.979 7.53107C14.979 8.02762 15.3928 8.35866 15.8066 8.35866Z" fill="#0990CF"></path></g></g></g><defs><clipPath id="clip0_4_4251"><rect width="48" height="48" fill="white"></rect></clipPath></defs></svg>                    
                <div class="wrapper-text-job">
                    <p class="title-category-job">${translations[localization].posted}</p>
                    <p class="title-content-job">${formattedDate}</p>
                </div>
            </div>
            <div class="icon-job">
                <!-- SVG del ícono de tipo -->
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_63_5633)"><mask id="mask0_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M-6.10352e-05 0H31.9999V32H-6.10352e-05V0Z" fill="white"></path></mask><g mask="url(#mask0_63_5633)"><mask id="mask1_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask1_63_5633)"><path d="M16.0272 29.6309C8.48161 29.6309 2.31294 23.4622 2.31294 15.9166C2.31294 8.31592 8.48161 2.20232 16.0272 2.20232C23.6279 2.20232 29.7415 8.31592 29.7415 15.9166C29.7415 23.4622 23.6279 29.6309 16.0272 29.6309ZM16.0272 1.10077C7.87576 1.10077 1.15631 7.76514 1.15631 15.9717C1.15631 24.1782 7.82068 30.8426 16.0272 30.8426C24.2338 30.8426 30.8981 24.1782 30.8981 15.9717C30.8981 7.76514 24.1787 1.10077 16.0272 1.10077Z" fill="#0164A1"></path></g><mask id="mask2_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask2_63_5633)">
                <path d="M16.027 7.3259C16.3574 7.3259 16.6328 7.05051 16.6328 6.77512V4.40679C16.6328 4.13141 16.3574 3.85602 16.027 3.85602C15.7516 3.85602 15.4762 4.13141 15.4762 4.40679V6.72005C15.4762 7.05051 15.7516 7.3259 16.027 7.3259Z" fill="#0164A1"></path></g><mask id="mask3_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask3_63_5633)"><path d="M16.027 24.3994C15.7516 24.3994 15.4762 24.6748 15.4762 24.9502V27.2635C15.4762 27.5389 15.7516 27.8142 16.027 27.8142C16.3574 27.8142 16.6328 27.5389 16.6328 27.2635V24.9502C16.5777 24.6748 16.3574 24.3994 16.027 24.3994Z" fill="#0164A1"></path></g><mask id="mask4_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask4_63_5633)"><path d="M27.4293 15.3115H25.1161C24.8407 15.3115 24.5653 15.5869 24.5653 15.8623C24.5653 16.1377 24.8407 16.413 25.1161 16.413H27.4293C27.7598 16.413 28.0352 16.1377 28.0352 15.8623C28.0352 15.5869 27.7598 15.3115 27.4293 15.3115Z" fill="#0164A1"></path></g>
                <mask id="mask5_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask5_63_5633)"><path d="M6.93992 15.3115H4.57159C4.2962 15.3115 4.02081 15.5869 4.02081 15.8623C4.02081 16.1377 4.2962 16.413 4.57159 16.413H6.88484C7.16023 16.413 7.43561 16.1377 7.43561 15.8623C7.43561 15.5869 7.2153 15.3115 6.93992 15.3115Z" fill="#0164A1"></path></g><mask id="mask6_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask6_63_5633)"><path d="M10.4107 6.11433C10.1353 6.27957 10.0252 6.61003 10.1904 6.88542C10.3557 7.16081 10.6861 7.27096 10.9615 7.10573C11.2369 6.9405 11.3471 6.61003 11.1818 6.33464C11.0166 6.00418 10.631 5.9491 10.4107 6.11433Z" fill="#0164A1"></path></g><mask id="mask7_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask>
                <g mask="url(#mask7_63_5633)"><path d="M20.9292 24.3445C20.6538 24.4547 20.5437 24.8402 20.7089 25.1156C20.8742 25.391 21.2046 25.5011 21.48 25.3359C21.7554 25.1707 21.8655 24.8402 21.7003 24.5648C21.5351 24.2894 21.2046 24.1793 20.9292 24.3445Z" fill="#0164A1"></path></g><mask id="mask8_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask8_63_5633)"><path d="M25.3899 10.9058C25.6653 10.7405 25.7203 10.4101 25.6102 10.1347C25.445 9.85929 25.1145 9.80421 24.8391 9.91437C24.5637 10.0796 24.5086 10.4101 24.6739 10.6855C24.729 10.9608 25.0594 11.071 25.3899 10.9058Z" fill="#0164A1"></path></g><mask id="mask9_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask9_63_5633)"><path d="M6.55368 20.4885C6.27829 20.6537 6.16814 20.9842 6.33337 21.2596C6.44353 21.535 6.82907 21.6451 7.10446 21.4799C7.37984 21.3697 7.49 20.9842 7.32477 20.7088C7.15953 20.4334 6.77399 20.3233 6.55368 20.4885Z" fill="#0164A1"></path></g>
                <mask id="mask10_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask10_63_5633)"><path d="M6.38904 10.8503C6.66442 11.0156 6.99489 10.9054 7.16012 10.63C7.32535 10.3546 7.27027 10.0242 6.99489 9.85893C6.7195 9.6937 6.38903 9.74878 6.2238 10.0792C6.05857 10.3546 6.11365 10.6851 6.38904 10.8503Z" fill="#0164A1"></path></g><mask id="mask11_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask11_63_5633)"><path d="M25.2246 20.4336C24.9492 20.2684 24.6188 20.3235 24.4535 20.5988C24.2883 20.8742 24.3985 21.2047 24.6739 21.3699C24.9492 21.4801 25.2797 21.425 25.4449 21.1496C25.5551 20.8742 25.5 20.5438 25.2246 20.4336Z" fill="#0164A1"></path></g><mask id="mask12_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask>
                <g mask="url(#mask12_63_5633)"><path d="M20.7645 6.94001C21.0399 7.10524 21.3704 7.05016 21.5356 6.77477C21.6457 6.49939 21.5907 6.16892 21.3153 6.00369C21.0399 5.83846 20.7094 5.94861 20.5442 6.224C20.434 6.49939 20.5442 6.82985 20.7645 6.94001Z" fill="#0164A1"></path></g><mask id="mask13_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask13_63_5633)"><path d="M10.7948 24.2899C10.5194 24.1247 10.1889 24.2348 10.0237 24.5102C9.85847 24.7856 9.91354 25.1161 10.244 25.2813C10.5194 25.4465 10.8499 25.3915 11.0151 25.061C11.1803 24.7856 11.0702 24.4551 10.7948 24.2899Z" fill="#0164A1"></path></g><mask id="mask14_63_5633" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="33" height="32"><path d="M-0.00012207 32H31.9999V0H-0.00012207V32Z" fill="white"></path></mask><g mask="url(#mask14_63_5633)"><path d="M16.0284 16.8531C15.5327 16.8531 15.0921 16.4125 15.0921 15.9168C15.0921 15.4211 15.5327 14.9805 16.0284 14.9805C16.5241 14.9805 16.9647 15.4211 16.9647 15.9168C16.9647 16.4125 16.5241 16.8531 16.0284 16.8531ZM21.5361 9.63796L17.0198 14.1543C16.9096 14.0442 16.7444 14.0442 16.5791 13.9891V11.5657C16.5791 11.2352 16.3038 10.9598 15.9733 10.9598C15.6979 10.9598 15.4225 11.2352 15.4225 11.5657V13.9891C14.5413 14.2645 13.9354 15.0355 13.9354 15.9719C13.9354 17.0734 14.8717 18.0097 15.9733 18.0097C17.0748 18.0097 18.0112 17.0734 18.0112 15.9719C18.0112 15.5863 17.901 15.2559 17.7358 14.9805L22.2521 10.4641C22.4724 10.1887 22.4724 9.85827 22.2521 9.69303C22.0869 9.41765 21.7564 9.41765 21.5361 9.63796Z" fill="#0164A1"></path></g></g></g><defs><clipPath id="clip0_63_5633"><rect width="32" height="32" fill="white"></rect></clipPath></defs></svg>
                <div class="wrapper-text-job">
                    <p class="title-category-job">${translations[localization].type}</p>
                    <p class="title-content-job">${type}</p>
                </div>
            </div>
            <div class="icon-job">
                <!-- SVG del ícono de tipo de trabajo -->
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4_4379)"><mask id="mask0_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 0H48V48H0V0Z" fill="white"></path></mask><g mask="url(#mask0_4_4379)"><mask id="mask1_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask1_4_4379)"><path d="M16.1929 26.6024C15.8624 26.6024 15.6145 26.7676 15.5319 27.0155C15.2841 27.1807 14.7884 27.1807 14.0448 27.1807C13.2187 27.1807 12.723 27.0981 12.4751 27.0155C12.3099 26.8503 12.062 26.6024 11.8142 26.6024C11.4011 26.6024 10.988 27.0155 10.988 27.5112C10.988 28.6678 12.8882 28.9157 14.0448 28.9157C15.2015 28.9157 17.019 28.7504 17.019 27.5112C17.019 26.9329 16.6886 26.6024 16.1929 26.6024Z" fill="#0990CF"></path></g><mask id="mask2_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask2_4_4379)"><path d="M9.41845 21.976C8.92275 21.976 8.59229 22.389 8.59229 22.8021C8.59229 23.2152 8.92275 23.6283 9.41845 23.6283C9.83153 23.6283 10.2446 23.2152 10.2446 22.8021C10.2446 22.389 9.83153 21.976 9.41845 21.976Z" fill="#0990CF"></path></g><mask id="mask3_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask3_4_4379)"><path d="M18.8364 21.976C18.4233 21.976 18.0103 22.389 18.0103 22.8021C18.0103 23.2152 18.4233 23.6283 18.8364 23.6283C19.2495 23.6283 19.6626 23.2152 19.6626 22.8021C19.6626 22.389 19.2495 21.976 18.8364 21.976Z" fill="#0990CF"></path></g>
                <mask id="mask4_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask4_4_4379)"><path d="M44.6128 44.1997H29.1636V26.9329H32.3856C32.7987 28.5026 34.1206 30.0723 35.4424 30.0723H36.9295C37.26 30.0723 37.7557 30.0723 38.4166 30.0723C39.6558 30.0723 40.9777 28.5026 41.4734 26.9329H44.6128V44.1997ZM35.112 24.3718H38.6645C39.3254 24.3718 39.9863 24.6196 39.9863 25.6937C39.9863 27.0155 38.8297 28.42 38.4166 28.42C37.5078 28.42 37.0121 28.42 36.9295 28.42H35.4424C35.0293 28.3374 33.7901 27.0155 33.7901 25.6937C33.7901 24.6196 34.5336 24.3718 35.112 24.3718ZM17.6799 30.6506C16.8538 31.0637 15.4493 31.2289 14.9536 31.2289H12.8882C12.4751 31.2289 11.0706 31.0637 10.1619 30.6506C9.41833 30.3202 7.2703 27.9243 6.93984 27.5112C6.85722 27.4286 6.77461 27.346 6.69199 27.1807C6.27891 26.7677 5.28752 25.6937 5.2049 24.7023C5.2049 24.3718 5.12228 23.6283 5.03967 22.8021V18.5887C5.94845 19.5801 6.85722 20.4888 7.84862 20.4888H19.828C20.902 20.4888 21.8108 19.5801 22.7195 18.5887V22.7195C22.5543 24.0413 22.5543 24.537 22.5543 24.7023C22.3891 25.611 21.4803 26.6851 21.0672 27.1807C20.9846 27.346 20.902 27.4286 20.8194 27.5112C20.5715 28.0069 18.4235 30.3202 17.6799 30.6506ZM4.37874 13.8795C4.37874 11.2358 5.37013 8.83996 7.10507 7.0224V14.5405H4.37874V13.8795ZM12.9708 3.55252H15.1188C15.2015 3.55252 15.2841 3.63514 15.2841 3.71775V14.5405H12.8056V3.71775C12.8056 3.63514 12.8056 3.55252 12.9708 3.55252ZM23.6283 13.8795V14.5405H20.8194V7.10502C22.5543 8.83996 23.6283 11.2358 23.6283 13.8795ZM16.9364 4.62653C17.7626 4.957 18.5061 5.28746 19.2496 5.78316V14.6231H16.9364V4.62653ZM22.6369 16.2754C22.4717 16.4406 22.3064 16.6885 22.1412 16.8537C21.5629 17.5147 20.4889 18.9191 19.9106 18.9191H8.01385C7.51815 18.9191
                6.36153 17.5147 5.78321 16.8537C5.61798 16.6885 5.45275 16.4406 5.28752 16.2754H22.6369ZM11.1533 14.5405H8.84001V5.78316C9.50094 5.28746 10.2445 4.957 11.1533 4.62653V14.5405ZM45.5216 25.2806H41.6386C41.4734 23.5456 40.0689 22.8021 38.6645 22.8021H35.112C33.7075 22.8021 32.3856 23.5456 32.1378 25.2806H28.2548C27.8417 25.2806 27.4287 25.6937 27.4287 26.1067V31.3116C25.8589 30.0723 23.4631 29.2462 21.976 28.8331C22.1412 28.6678 22.2238 28.5852 22.2238 28.5852C22.2238 28.5026 22.3064 28.42 22.3891 28.42C22.9674 27.7591 24.0414 26.5198 24.2892 25.1153C24.3719 24.7023 24.4545 24.0413 24.4545 22.8847V16.7711C24.5371 16.6059 24.5371 16.4406 24.5371 16.358H25.2806C25.7763 16.358 26.1894 15.9449 26.1894 15.4493C26.1894 15.0362 25.7763 14.6231 25.2806 14.6231V13.9622C25.2806 10.327 23.6283 7.0224 20.8194 4.957V4.79176C20.8194 4.37868 20.4063 3.9656 19.9932 3.9656C19.828 3.9656 19.6627 4.04822 19.5801 4.13083C18.6713 3.55252 17.6799 3.22206 16.6059 2.97421C16.2755 2.39589 15.6972 2.06543 15.0362 2.06543H12.8882C12.2273 2.06543 11.5663 2.47851 11.2359 2.97421C10.1619 3.22206 9.25309 3.63514 8.2617 4.13083C8.2617 3.9656 8.09647 3.9656 7.93123 3.9656C7.51815 3.9656 7.10507 4.37868 7.10507 4.79176V4.957C4.37874 7.0224 2.6438 10.327 2.6438 13.9622V14.6231C2.1481 14.6231 1.73502 15.0362 1.73502 15.4493C1.73502 15.9449 2.1481 16.358 2.6438 16.358H3.46996C3.46996 16.5233 3.46996 16.6059 3.55258 16.7711V22.9673C3.63519 23.9587 3.71781 24.7023 3.71781 25.1153C3.88304 26.5198 5.03967 27.8417 5.61798 28.42C5.7006 28.5026 5.78321 28.5852 5.78321 28.5852C5.78321 28.5852 5.86583 28.7505 5.94845 28.8331C4.95705 29.0809 3.46996 29.5766 2.23072 30.2375C1.81764 30.4028 1.56979 30.8985 1.81764 31.3942C1.98287 31.642 2.23072 31.8073 2.56118 31.8073C2.72641 31.8073 2.72641 31.8073 2.89165 31.7246C4.54397 30.8985 6.36153 30.4028 7.18769 
                30.2375C8.01385 31.1463 8.92263 31.9725 9.58356 32.2203C10.7402 32.7986 12.3925 32.8813 12.9708 32.8813H15.0362C15.6145 32.8813 17.2669 32.716 18.4235 32.2203C19.0844 31.9725 20.0758 31.0637 20.8194 30.3202C23.2978 30.8985 27.5113 32.3856 27.5113 34.2031V45.1911C27.5113 45.6042 27.9243 46.0172 28.3374 46.0172H45.5216C45.9347 46.0172 46.3478 45.6042 46.3478 45.1911V26.1067C46.3478 25.611 45.9347 25.2806 45.5216 25.2806Z" fill="#0990CF"></path></g><mask id="mask5_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask5_4_4379)"><path d="M41.3909 32.0549H32.2205C31.7248 32.0549 31.3118 32.468 31.3118 32.8811C31.3118 33.3768 31.7248 33.7899 32.2205 33.7899H41.3909C41.8866 33.7899 42.2997 33.3768 42.2997 32.8811C42.2997 32.468 41.8866 32.0549 41.3909 32.0549Z" fill="#0990CF"></path></g><mask id="mask6_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask6_4_4379)"><path d="M41.3909 36.0208H32.2205C31.7248 36.0208 31.3118 36.3512 31.3118 36.8469C31.3118 37.26 31.7248 37.6731 32.2205 37.6731H41.3909C41.8866 37.6731 42.2997 37.26 42.2997 36.8469C42.2997 36.3512 41.8866 36.0208 41.3909 36.0208Z" fill="#0990CF"></path></g><mask id="mask7_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask7_4_4379)"><path d="M37.508 39.9034H32.2205C31.7248 39.9034 31.3118 40.3165 31.3118 40.7296C31.3118 41.2253 31.7248 41.6384 32.2205 41.6384H37.508C38.0037 41.6384 38.4168 41.2253 38.4168 40.7296C38.3341 40.3165 38.0037 39.9034 37.508 39.9034Z" fill="#0990CF"></path></g>
                <mask id="mask8_4_4379" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48"><path d="M0 48H48V0H0V48Z" fill="white"></path></mask><g mask="url(#mask8_4_4379)"><path d="M40.8123 39.821C40.3166 39.821 39.9036 40.2341 39.9036 40.7298C39.9036 41.2255 40.3166 41.6386 40.8123 41.6386C41.3907 41.6386 41.7211 41.2255 41.7211 40.7298C41.7211 40.2341 41.3907 39.821 40.8123 39.821Z" fill="#0990CF"></path></g></g></g><defs><clipPath id="clip0_4_4379"><rect width="48" height="48" fill="white"></rect></clipPath></defs></svg>
                <div class="wrapper-text-job">
                    <p class="title-category-job">${translations[localization].job_type}</p>
                    <p class="title-content-job">${jobType}</p>
                </div>
            </div>
        `;
    }

    // Crear tarjeta de trabajo principal
    if (jobElement) {
        const jobCard = document.createElement("div");
        jobCard.classList.add("job-card");
        var filteredQueryString = window.queryString ? window.queryString : "";

        const applyUrl = jobFiltered.External_Apply_URL ? jobFiltered.External_Apply_URL.replace("https://jabil4.wd5.myworkdayjobs-impl.com/", "https://jabil.wd5.myworkdayjobs.com/") + (filteredQueryString ? "?" + filteredQueryString : "") : "#";

        jobCard.innerHTML = `
            <div class="header-job job-grid">
                <p>${jobFiltered.Job_Req_Header || ""}</p>
                <div class="col-right">
                    <div>
                        <a class="button" href="${applyUrl}" target="_blank">
                            Apply now 
                            <div class="icon-container">
                                <svg class="button-icon icon--arrow-icon-right">
                                    <use xlink:href="#arrow-icon-right"></use>
                                </svg>
                            </div>
                        </a>
                    </div>
                    <div class="share">
                        <div style="display: flex;">
                            <svg class="icon small"><use xlink:href="#share"></use></svg>
                            <h4>SHARE</h4>
                        </div>
                        <ul class="social-media">
                            <li class="linkedin">
                                <a rel="noopener" href="https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=${emailSubject}&source=${encodeURIComponent(currentUrl)}" title="linkedin" target="_blank" aria-label="LinkedIn">
                                    <svg class="icon"><use xlink:href="#linkedin"></use></svg>
                                </a>
                            </li>
                            <li class="facebook">
                                <a rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}&t=${emailSubject}" title="facebook" target="_blank" aria-label="Facebook">
                                    <svg class="icon"><use xlink:href="#facebook"></use></svg>
                                </a>
                            </li>
                            <li class="x">
                                <a rel="noopener" href="https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${emailSubject}" title="x.com" target="_blank" aria-label="X">
                                    <svg class="icon"><use xlink:href="#x"></use></svg>
                                </a>
                            </li>
                            <li class="email">
                                <a rel="noopener" href="mailto:?subject=${emailSubject}&body=${emailBody}" title="email" target="_blank" aria-label="Email">
                                    <svg class="icon"><use xlink:href="#email"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="job-grid">
                <div class="wrapper-jobs">
                    <div class="job-description-container">
                        <h2>job description</h2>
                        ${finalDescription}
                        ${aditionalDescription}
                    </div>
                    <div class="footer-job">
                        ${jobFiltered.Job_Req_Footer || ""}
                        ${jobFiltered.Warning_Message ? `<p style="margin-top: 1rem; color: var(--text, #2d2c2e);font-size: 18px;font-weight: 400;line-height: 1.5;">${jobFiltered.Warning_Message}</p>` : ""}
                        ${jobFiltered["CF_RECR_Job_Req_WA__CA_and_CO_-_Comp_Range_Text_1"] ? `<p style="margin-top: 1rem; color: var(--text, #2d2c2e);font-size: 18px;font-weight: 400;line-height: 1.5;">${jobFiltered["CF_RECR_Job_Req_WA__CA_and_CO_-_Comp_Range_Text_1"]}</p>` : ""}
                        ${jobFiltered["CF_RECR_Job_Req_Colorado_-_Comp_Range_Text_2"] ? `<p style="margin-top: 1rem; color: var(--text, #2d2c2e);font-size: 18px;font-weight: 400;line-height: 1.5;">${jobFiltered["CF_RECR_Job_Req_Colorado_-_Comp_Range_Text_2"]}</p>` : ""}
                        ${jobFiltered.CF_RECR_EE_Accommodations_Statement ? `<div class="job-grid"><div class="wrapper-jobs"><div class="job-description-container"><span class="subtitle-jobs">Accommodation Statement</span>${jobFiltered.CF_RECR_EE_Accommodations_Statement}</div></div>` : ""}
                        
                        <div class="hashtag-jobs">${jobFiltered["Job_Board_Keyword_-_Handshake"] || ""}</div>
                        <div class="hashtag-jobs">${jobFiltered["Job_Board_Keyword_-_Indeed"] || ""}</div>
                        <div class="hashtag-jobs">${jobFiltered["Job_Board_Keyword_-_Jobtip"] || ""}</div>
                        
                        <a class="button" href="${applyUrl}" target="_blank">
                            Apply now 
                            <div class="icon-container">
                                <svg class="button-icon icon--arrow-icon-right">
                                    <use xlink:href="#arrow-icon-right"></use>
                                </svg>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            
            <div id="similar-jobs" class="similar-jobs-container">
                ${videoPlayerHTML}
                <div class="container-title">
                    <h2>${translations[localization].similar_job_title}</h2>
                    <div class="line-style"></div>
                </div>
                <ul></ul>
            </div>
        `;

        jobElement.appendChild(jobCard);
    }

    return jobFiltered;
}

// ===== INICIALIZACIÓN PRINCIPAL =====
async function init() {
    try {
        // 1. Inicializar traducciones
        initializeTranslations();

        // 2. Configurar base URL
        baseUrl = window.location.origin;
        if (window.location.hostname.includes("localhost")) {
            baseUrl += "/local";
        }

        // 3. Obtener datos del servidor
        const jcrPath = window.jcrPath;
        jobItem = window.jobItem;

        if (!jcrPath || !jobItem) {
            console.error("jcrPath o jobItem no encontrados");
            return;
        }

        // 4. Cargar categorías
        statesList = await getCategories("state");
        locationsList = await getCategories("location");
        jobAreasList = await getCategories("job_area");

        // Hacer disponibles globalmente
        window.statesList = statesList;
        window.locationsList = locationsList;
        window.jobAreasList = jobAreasList;

        // 5. Cargar datos del trabajo
        const url = baseUrl + "/dam/jcr:" + jcrPath;
        const response = await fetch(url);

        if (response.ok) {
            const data = await response.json();
            const jobsData = data.Report_Entry;
            const jobFiltered = jobsData.find(item => item.Job_Requisition_ID.toLowerCase() === jobItem.toLowerCase());

            const loader = document.querySelector(".lds-ellipsis");
            const jobItemContainer = document.querySelector("#job-item");

            if (jobFiltered) {
                // Renderizar trabajo
                const currentUrl = window.location.href;
                const articleTitle = document.title || "";

                renderJobItem(jobFiltered, currentUrl, articleTitle);
                setRelatedJobs(jobFiltered, jobsData);

                // Mostrar contenido
                if (loader) {
                    loader.style.opacity = "0";
                    loader.style.minHeight = "unset";
                }
                if (jobItemContainer) {
                    jobItemContainer.style.opacity = "1";
                }
            } else {
                // Mostrar error de trabajo no encontrado
                const notFoundElement = document.getElementById("not-found");
                if (loader) loader.style.opacity = "0";
                if (jobItemContainer) jobItemContainer.style.opacity = "1";
                if (notFoundElement) notFoundElement.classList.remove("hidden");
            }
        }
    } catch (error) {
        console.error("Error initializing job item:", error);
    }
}

// ===== EXPORT =====
export default { init };
